import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zgjjdpnm4g: FaireBrandEntity = {
  token: "b_zgjjdpnm4g",
  type: "brand",
  name: "Fresh Fizz Sodas",
  avatarUrl:
    "https://cdn.faire.com/fastly/abdacc4b5da223b614b96389552f427ec71417d211229301ea55073f5b92bd6a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3a56414221885f57506dda46b7ada2b8686119d12038e1aee05b143c7fd575bd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/abdacc4b5da223b614b96389552f427ec71417d211229301ea55073f5b92bd6a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a56414221885f57506dda46b7ada2b8686119d12038e1aee05b143c7fd575bd.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 16,
  isInsider: true,
  description:
    "At Fresh Fizz Sodas, we believe the secret to incredible flavor is using only real food ingredients- that's why our natural sodas are simply made with fresh herbs and spices, real fruit juice, and a bit of honey and maple syrup.\n\nOur flavors include Sparkling Mint Lemonade, Sparkling Jalapeño Limeade, Hibiscus Ginger Ale, and Blood Orange Cola (coming soon). \n\nWe use no processed sugars, no preservatives, no artificial ingredients, not even 'natural flavors' or extracts. Just real food ingredients you recognize.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:06.299Z",
    importedBy: "entity-db-cli",
  },
};
